<template>
  <nav class="absolute flex flex-wrap items-center justify-between py-4 w-full">
    <div class="w-full px-4 flex flex-wrap items-center justify-between z-10" :class="{ 'bg-white': isOpen }">
      <div class="w-full relative flex justify-between xl:w-auto xl:block xl:justify-start -mr-6">
        <inertia-link :href="route('home')">
          <div class="bg-white transform -skew-x-25 py-4 px-16 xl:px-10 transform -translate-x-12"
               :class="{ 'pr-60 transition-all' : showingNavigationDropdown}">
            <img src="/images/logo.svg" alt="Logo" class="pl-4 transform skew-x-25">
          </div>
        </inertia-link>
        <div class="xl:hidden relative flex items-center">
          <input id="menubutton" type="checkbox" v-model="isOpen"
                 class="absolute h-full inset-0 h-12 w-6 cursor-pointer text-xl border-transparent bg-transparent xl:hidden"
                 style="left: -100vw;"/>
          <label for="menubutton" class="cursor-pointer h-full flex flex-col justify-center">
            <span class="block relative w-6 h-px rounded-sm bg-white lg:bg-dark-blue"
                  :class="{ 'bg-dark-blue': isOpen }"></span>
            <span class="block relative w-6 h-px rounded-sm bg-white lg:bg-dark-blue mt-1"
                  :class="{ 'bg-dark-blue': isOpen }"></span>
            <span class="block relative w-6 h-px rounded-sm bg-white lg:bg-dark-blue mt-1"
                  :class="{ 'bg-dark-blue': isOpen }"></span>
          </label>
        </div>
      </div>

      <div class="xl:flex flex-grow items-center justify-between py-4 xl:py-0 " :class="{ 'hidden' : !isOpen}">
        <ul class="flex flex-col xl:flex-row list-none text-white -px-4" :class="{ 'text-dark-blue': isOpen }">
          <li class="px-4">
            <nav-link :href="route('home')" anchor="#what-is-it" :same-page="home">
              {{ $trans('app.menu.what-is-it') }}
            </nav-link>
          </li>
          <!--<li class="px-4">-->
          <!--  <nav-link :href="route('home')" anchor="#pricing" :same-page="home">-->
          <!--    {{ $trans('app.menu.pricing') }}-->
          <!--  </nav-link>-->
          <!--</li>-->
          <li class="px-4">
            <nav-link :href="route('home')" anchor="#how-it-works" :same-page="home">
              {{ $trans('app.menu.how-it-works') }}
            </nav-link>
          </li>
          <li class="px-4">
            <nav-link :href="route('home')" anchor="#who-we-are" :same-page="home">
              {{ $trans('app.menu.who-we-are') }}
            </nav-link>
          </li>
          <li class="px-4" v-if="$page.props.reviews && $page.props.reviews.length > 0">
            <nav-link :href="route('home')" anchor="#testimonials" :same-page="home">
              {{ $trans('app.menu.testimonials') }}
            </nav-link>
          </li>
        </ul>
        <div class="px-4">
          <div class="flex px-1">
            <menu-account/>
          </div>
        </div>
        <!--<button @click="changeLang">-->
        <!--    EN / FR-->
        <!--</button>-->
      </div>
    </div>
  </nav>
</template>

<script>
import NavLink from '@/Components/NavLink'
import MenuAccount from "./MenuAccount";

export default {
  components: {
    MenuAccount,
    NavLink,
  },
  props: {
    home: {}
  },
  data() {
    return {
      showingNavigationDropdown: false,
      isOpen: false,
    }
  },

  watch: {
    showingNavigationDropdown() {
      // console.log(this.showingNavigationDropdown);
    }
  },

  methods: {
    closeMenu() {
      this.isOpen = false
    },
    changeLang() {
      console.log(this.$locales())
    }
  }

}
</script>

<style lang="scss" scoped>
@screen md {
  nav.nav-white {
    @apply bg-white py-0 transition-all;

    & ul li a {
      @apply xl:text-dark-blue;
    }
  }
}
</style>
